document.querySelectorAll('.tabs-section').forEach(tabsSection => {

  const buttons = tabsSection.querySelectorAll('.tab-btn');
  const panes = tabsSection.querySelectorAll('.tab-pane');
  const coveragePane = tabsSection.querySelector('#cobertura');
  const coverageToggle = tabsSection.querySelector('.js-coverage-tab-toggle');
  const coverageContent = tabsSection.querySelector('.js-coverage-tab-content');
  const activationCheckTrigger = tabsSection.querySelector('[data-open-device-checker]');
  const mainEsimCheckerBtn = document.getElementById('open-esim-checker');
  const collapsedHeight = 150;

  const syncCoverageView = () => {
    if (!coveragePane || !coverageToggle || !coverageContent) return;

    const hasOverflow = coverageContent.scrollHeight > collapsedHeight + 2;
    coveragePane.classList.toggle('is-no-toggle', !hasOverflow);
    coverageToggle.hidden = !hasOverflow;

    if (!hasOverflow) {
      coveragePane.classList.remove('is-expanded');
      coverageToggle.textContent = coverageToggle.dataset.more;
    }
  };

  if (coveragePane && coverageToggle) {
    coverageToggle.addEventListener('click', function () {
      coveragePane.classList.toggle('is-expanded');
      this.textContent = coveragePane.classList.contains('is-expanded')
        ? this.dataset.less
        : this.dataset.more;
    });
  }

  if (activationCheckTrigger && mainEsimCheckerBtn) {
    activationCheckTrigger.addEventListener('click', function () {
      mainEsimCheckerBtn.click();
    });
  }

  buttons.forEach(button => {
    button.addEventListener('click', function () {

      // Reset SOLO dentro de este bloque
      buttons.forEach(btn => btn.classList.remove('active'));
      panes.forEach(pane => pane.classList.remove('active'));

      // Activar botón
      this.classList.add('active');

      // Mostrar panel correcto
      const tabId = this.dataset.tab;
      const pane = tabsSection.querySelector(`#${tabId}`);
      if (pane) pane.classList.add('active');

      if (tabId === 'cobertura') {
        requestAnimationFrame(syncCoverageView);
      } else if (coveragePane && coverageToggle) {
        coveragePane.classList.remove('is-expanded');
        coverageToggle.textContent = coverageToggle.dataset.more;
      }

    });
  });

  window.addEventListener('resize', () => {
    if (coveragePane?.classList.contains('active')) {
      syncCoverageView();
    }
  });

});
